import React from "react";
import { Form, Col, Container, Row } from "react-bootstrap";

const CleanedAddressFilters = ({ onFilterChange, onSearch, filters = {} }) => {
  return (
    <Container className="mt-4">
      <Form onKeyDown={(e) => { if (e.key === 'Enter' && !['TEXTAREA', 'SELECT'].includes(e.target.tagName)) { e.preventDefault(); onSearch?.(); } }}>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="dateFrom">
              <Form.Label>Data od</Form.Label>
              <Form.Control
                type="date"
                value={filters.dateFrom || ""}
                onChange={(e) => onFilterChange("dateFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="dateTo">
              <Form.Label>Data do</Form.Label>
              <Form.Control
                type="date"
                value={filters.dateTo || ""}
                onChange={(e) => onFilterChange("dateTo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalDR">
              <Form.Label>Terminal DR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.terminalDR || filters.terminalDr || ""}
                onChange={(e) => onFilterChange("terminalDR", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalEX">
              <Form.Label>Terminal EX</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.terminalEX || filters.terminalEx || ""}
                onChange={(e) => onFilterChange("terminalEX", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default CleanedAddressFilters;
